import { http, type HttpResponse } from 'interfaces'

export interface PersonPictureInformation {
  id?: number | null
  person_id?: number | null
  image?: string | null
  display_order?: number | null
  updated_by?: string | null
  last_updated?: Date | string | null
}
export async function getPersonPicture (personId: number): Promise<HttpResponse<PersonPictureInformation>> {
  return await http
    .get(`/api/v1/us/people/picture/${personId}/`, {
    }).then(value => {
      return value.data
    })
}

export async function createNewPersonPicture (base64Str: string, personId: number): Promise<HttpResponse<PersonPictureInformation>> {
  return await http
    .post(`/api/v1/us/people/picture/${personId}/`, { image: base64Str }).then(value => {
      return value.data
    })
}

export async function listPersonPictures (personId: number): Promise<HttpResponse<PersonPictureInformation[]>> {
  return await http
    .get(`/api/v1/us/people/picture/${personId}/all/`, {
    }).then(value => {
      return value.data
    })
}

export async function deletePersonPicture (personId: number, imageId: number): Promise<HttpResponse<PersonPictureInformation[]>> {
  return await http
    .delete(`/api/v1/us/people/picture/${personId}/${imageId}/`, {
    }).then(value => {
      return value.data
    })
}
